var map = {
	"./01_hero_desktop.jpg": 641,
	"./01_hero_mobile.jpg": 642,
	"./01_hero_tablet.jpg": 643,
	"./01_twitter_image.jpg": 644,
	"./02_hero_desktop.jpg": 645,
	"./02_hero_mobile.jpg": 646,
	"./02_hero_tablet.jpg": 647,
	"./02_twitter_image.jpg": 648,
	"./03_hero_desktop.jpg": 649,
	"./03_hero_mobile.jpg": 650,
	"./03_hero_tablet.jpg": 651,
	"./03_twitter_image.jpg": 652,
	"./04_hero_desktop.jpg": 653,
	"./04_twitter_image.jpg": 654,
	"./05_hero_desktop.jpg": 655,
	"./05_twitter_image.jpg": 656,
	"./06_hero_desktop.jpg": 657,
	"./06_twitter_image.jpg": 658,
	"./07_hero_desktop.jpg": 659,
	"./07_twitter_image.jpg": 660,
	"./08_hero_desktop.jpg": 661,
	"./08_twitter_image.jpg": 662,
	"./09_hero_desktop.jpg": 663,
	"./09_twitter_image.jpg": 664,
	"./10_hero_desktop.jpg": 665,
	"./10_twitter_image.jpg": 666,
	"./11_hero_desktop.jpg": 667,
	"./11_twitter_image.jpg": 668,
	"./12_the-urban-farm-sending-meals-to-children.jpg": 669,
	"./12_the-urban-farm-sending-meals-to-children_twitter_image.jpg": 670,
	"./22_hero_desktop.jpg": 671,
	"./22_twitter_image.jpg": 672,
	"./2ATH3BK.crop-twitter.jpg": 673,
	"./2ATH3BK.crop.jpg": 674,
	"./ABENT3.crop-twitter.jpg": 675,
	"./ABENT3.crop.jpg": 676,
	"./James-wong-hero.jpg": 677,
	"./James-wong-twitter.jpg": 678,
	"./LNC-aggregates-on-sand-2-crop.jpg": 679,
	"./Seawatergreenhouseaus_crop.jpg": 680,
	"./Seawatergreenhouseaus_crop_twitter.jpg": 681,
	"./Thought-leaders-hero.jpg": 682,
	"./Thought-leaders-twitter.jpg": 683,
	"./africa_getty.jpg": 684,
	"./africa_getty_twitter.jpg": 685,
	"./cattle-drones-twitter.jpg": 686,
	"./cattle-drones_hero.jpg": 687,
	"./food-chain_hero_desktop.jpg": 688,
	"./food_chain_twitter_image.jpg": 689,
	"./how-covid-19-is-changing-food-shopping-twitter-image.jpg": 690,
	"./how-covid-19-is-changing-food-shopping.jpg": 691,
	"./kiwi-picker-robotics-twitter.jpg": 692,
	"./kiwi-picker-robotics.jpg": 693,
	"./the-freedom-soup-twitter.jpg": 694,
	"./the-freedom-soup.jpg": 695,
	"./the-green-milk-made-from-cells-twitter.jpg": 696,
	"./the-green-milk-made-from-cells.jpg": 697,
	"./the-massive-farms-emerging-beneath-our-cities.jpg": 698,
	"./the-massive-farms-emerging-beneath-our-cities_twitter_image.jpg": 699,
	"./the-simple-shellfish-that-fights-climate-change_hero.jpg": 700,
	"./the-simple-shellfish-that-fights-climate-change_twitter.jpg": 701,
	"./the_invisible_women_article.jpg": 702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 314;